import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { traceTargets } from './environments/environment.prod';
if (environment.production) {
  enableProdMode();
}
Sentry.init({
  dsn: 'https://9a5bff3909e45a732ff18ee4176a09eb@o1396046.ingest.us.sentry.io/4507364046274560',
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracePropagationTargets: traceTargets,
  tracesSampleRate: 1.0,
  environment: environment.production ? 'prod' : 'qa',
});
if (Capacitor.isNativePlatform()) {
  import('@sentry/capacitor').then((SentryCapacitor) => {
    SentryCapacitor.init({
      dsn: 'https://9a5bff3909e45a732ff18ee4176a09eb@o1396046.ingest.us.sentry.io/4507364046274560',
      environment: environment.production ? 'prod' : 'qa',
    });
  });
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
